import React from 'react'
import 'normalize.css'
import GlobalStyles from '../../styles/GlobalStyles'
import Navigation from './Navigation'

export default function Layout({ children }) {
  return (
    <>
      <GlobalStyles />
      <Navigation />
      {children}
    </>
  )
}
